import { render, staticRenderFns } from "./familyGroupInclusionUpdate.vue?vue&type=template&id=067ed8be&"
import script from "./familyGroupInclusionUpdate.vue?vue&type=script&lang=js&"
export * from "./familyGroupInclusionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports